import React from 'react';
import { Reveal } from './Reveal';
type Review = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const reviews: Review[] = [{
  initials: 'CF',
  quote: 'I opened Volume 1 on a Sunday afternoon and by Monday I had completely restructured how I prepare for sessions. The therapeutic question library organized by emotional territory is unlike anything I’ve seen in years of studying. I immediately used 15 questions I never would have thought of on my own. My clients felt completely seen and understood. This changed everything about how I work.',
  name: 'Catherine F.',
  role: 'Melbourne, Australia · Therapeutic Tarot Reader'
}, {
  initials: 'AP',
  quote: 'The protection and boundary bonuses saved my practice. I was burning out. I couldn’t turn off client energy. I felt their pain constantly after sessions. The grounding protocols and energetic protection practices are simple but profoundly effective. After two weeks of using them consistently, I feel like a completely different person. I actually love this work again and have energy for my personal life.',
  name: 'Amanda P.',
  role: 'Berlin, Germany · Energy Healer & Wellness Coach'
}, {
  initials: 'FG',
  quote: 'The professional documentation and ethics volumes gave me confidence I didn’t have before. I was genuinely worried I was crossing lines into therapy territory without realizing it. Now I have clear scope of practice guidelines, informed consent templates, and ethical protocols I follow in every single session. I feel legitimate. My clients absolutely feel it too and trust me more.',
  name: 'Francesca G.',
  role: 'Barcelona, Spain · Spiritual Coach & Practitioner'
}];
export function Reviews() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-202" data-mp="3stegoizjwrv4">
      <div className="mx-auto max-w-6xl" data-id="element-203" data-mp="3suxxcap4d4xf">
        <Reveal className="text-center" data-id="element-204" data-mp="3o36g4qrusbjy">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-205" data-mp="3o1d8p99f1naw">
            ⭐ More Real Results from <span className="text-sage" data-id="element-206" data-mp="1m6p78skffd2x">Real Practitioners</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-207" data-mp="1r4qr3fpofgfg">
            4.9/5 · Thousands already building their professional practice worldwide.
          </p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-208" data-mp="1cdqhh7d71ghq">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.05} data-id="element-209" data-mp="13ewf10d6lvw9" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-7 shadow-premium" data-id="element-210" data-mp="13dbmfgafgn11">
                <div className="text-amber" aria-label="5 out of 5 stars" data-id="element-211" data-mp="18bwntj1f1cr2">
                  ★★★★★
                </div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-212" data-mp="yfjtciy1quv9">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-213" data-mp="2nv9hkqvh93c2">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-214" data-mp="2su2xepy8l6fe">
                    {review.initials}
                  </span>
                  <span data-id="element-215" data-mp="c85y5cv6y4j7">
                    <span className="block font-bold text-navy" data-id="element-216" data-mp="c8peip570kv4">{review.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-217" data-mp="qxc6prfx573r">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}